import React from 'react'
import { withTheme } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const Component = (props) => (
  <CheckCircleIcon style={{color: props.theme.palette.common.green}} {...props} />
)
export default withTheme(Component)